import { ProductActionType } from '../../../../core/enums/product-actions/product-action-type.enum';

export class GrocyDashboardState {
  constructor(
    public isLoadingByBarcode = false,
    public isLoadingByProductId = false,
    public isSubmitting = false,
    public productActionType = ProductActionType.Consume
  ) {}

  get isLoading(): boolean {
    return this.isLoadingByBarcode || this.isLoadingByProductId;
  }

  set isLoading(value: boolean) {
    this.isLoadingByBarcode = value;
    this.isLoadingByProductId = value;
  }
}
